import { render, staticRenderFns } from "./CustomerTypeFilter.vue?vue&type=template&id=16bf30dc&"
import script from "./CustomerTypeFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTypeFilter.vue?vue&type=style&index=0&id=16bf30dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports